import React from "react";
import "../sass/Input.scss";

const Input = ({
  value,
  label,
  name,
  placeholder,
  type,
  onChange,
  onKeyPress,
}) => {
  // const [, set] = useState();
  // useEffect(() => {
  //     set();
  // }, []);

  return (
    <div className="InputField">
      <input
        type={type}
        value={value}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onKeyPress={onKeyPress}
      />
      {label && <label>{label}</label>}
    </div>
  );
};

export default Input;
